<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="12"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-row dense no-gutters>
              <v-col cols="12">

                <v-row
                  dense
                >
                  <v-col
                    cols="6"
                    class="text-right"
                  >
                    <v-text-field
                      dense
                      label="Ticket ID"
                      v-model="ticket"
                      :rules="[rules.required]"
                      type="text"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    class="text-right"
                  >
                    <v-text-field
                      dense
                      label="Domain"
                      v-model="domain"
                      :rules="[rules.required]"
                      type="text"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    class="text-right"
                  >
                    <v-text-field
                      dense
                      label="Purpose"
                      v-model="purpose"
                      :rules="[rules.required]"
                      type="text"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  dense
                >
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="processing"
                      @click="submitForm"
                    >Submit</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AgentTicketNew',
  components: {
  },
  created() {
  },
  data() {
    return {
      processing: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      valid: false,
      ticket: '',
      domain: '',
      purpose: '',
      form: {
      },
    };
  },
  methods: {
    submitForm() {
      this.processing = true;
      if (this.$refs.form.validate()) {
        this.$api.post('agent/ticket', {
          ticket: this.ticket,
          domain: this.domain,
          purpose: this.purpose,
        }).then((response) => {
          this.$router.push({
            name: 'AgentTicketDetail',
            params: { id: response.data.agent_ticket_id },
          });
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: 'ticket request is acknowledged successfully.',
          });
        }).finally(() => {
          this.processing = false;
        });
      } else {
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
